import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TripManagerFacade } from '../+state/trip-manager/trip-manager.facade';
import {
  PostedAircraftTripSkeleton,
  PostedAircraftTripAudit,
  PostedAircraftTripLegAudit
} from '../+models/trip-manager-audit.model';

@Component({
  selector: 'sd-portal-trip-manager-audit',
  templateUrl: './trip-manager.component.html',
  styleUrls: ['./trip-manager.component.scss']
})
export class TripManagerComponent implements OnInit {
  postedAircraftTripSkeletonsLoading$: Observable<boolean>;
  postedAircraftTripSkeletonsLoaded$: Observable<boolean>;
  postedAircraftTripSkeletons$: Observable<PostedAircraftTripSkeleton[]>;

  postedAircraftTripAuditLoading$: Observable<boolean>;
  postedAircraftTripAuditLoaded$: Observable<boolean>;
  postedAircraftTripAudit$: Observable<PostedAircraftTripAudit[]>;

  postedAircraftTripLegAuditLoading$: Observable<boolean>;
  postedAircraftTripLegAuditLoaded$: Observable<boolean>;
  postedAircraftTripLegAudit$: Observable<PostedAircraftTripLegAudit[]>;

  constructor(readonly tripManagerFacade: TripManagerFacade) {}

  ngOnInit() {
    this.postedAircraftTripSkeletonsLoading$ =
      this.tripManagerFacade.postedAircraftTripSkeletonsLoading$;
    this.postedAircraftTripSkeletonsLoaded$ =
      this.tripManagerFacade.postedAircraftTripSkeletonsLoaded$;
    this.postedAircraftTripSkeletons$ = this.tripManagerFacade.postedAircraftTripSkeletons$;

    this.postedAircraftTripAuditLoading$ = this.tripManagerFacade.postedAircraftTripAuditLoading$;
    this.postedAircraftTripAuditLoaded$ = this.tripManagerFacade.postedAircraftTripAuditLoaded$;
    this.postedAircraftTripAudit$ = this.tripManagerFacade.postedAircraftTripAudit$;

    this.postedAircraftTripLegAuditLoading$ =
      this.tripManagerFacade.postedAircraftTripLegAuditLoading$;
    this.postedAircraftTripLegAuditLoaded$ =
      this.tripManagerFacade.postedAircraftTripLegAuditLoaded$;
    this.postedAircraftTripLegAudit$ = this.tripManagerFacade.postedAircraftTripLegAudit$;

    this.tripManagerFacade.loadPostedAircraftTripSkeletons();
  }
}
